import Scrolling from '../utils/class/scrolling';

const QUERIES = {
    menu: '.site-menu',
    toggle: '.site-menu-toggle',
    close: null,
};

const BREAKPOINT = 1199;

export default class Menu {
    constructor(queries = QUERIES, breakpoint = BREAKPOINT) {
        const menu = document.querySelector(queries.menu) || document.querySelector(QUERIES.menu);
        if (!menu) return;

        const toggles = document.querySelectorAll(queries.toggle || QUERIES.toggle);
        if (!toggles.length) return;

        const close = queries.close ? document.querySelector(queries.close) : null;

        this.menu = menu;
        this.toggles = [...toggles];
        this.close = close;
        this.controls = menu.querySelectorAll('li > a');
        this.breakpoint = breakpoint || BREAKPOINT;
        this.overlay = document.querySelector('.site-header--overlay');
        this.scrolling = new Scrolling();

        this.init();
    }

    init() {
        this.handleToggle();
        this.handleResize();
        this.handleControls();
    }

    handleToggle() {
        this.toggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const opened = this.menu.classList.contains('opened');
                if (opened) {
                    this.handleClose()
                } else {
                    this.handleOpen();
                }
            });
        });

        if (this.close) {
            this.close.addEventListener('click', () => {
                this.handleClose();
            });
        }
    }

    handleResize() {
        window.addEventListener('resize', () => {
            if (window.innerWidth > this.breakpoint) this.handleClose();
        });
    }

    handleControls() {
        if (!this.controls.length) return;

        this.controls.forEach((control) => {
            control.addEventListener('click', () => {
                this.handleClose();
            });
        });
    }

    handleOpen() {
        this.menu.classList.add('opened');
        this.overlay.classList.add('visible');

        this.toggles.forEach((toggle) => {
            toggle.classList.add('opened');
        });

        this.scrolling.disable();

        document.documentElement.classList.add('locked');
    }

    handleClose() {
        this.menu.classList.remove('opened');
        this.overlay.classList.remove('visible');
        this.toggles.forEach((toggle) => {
            toggle.classList.remove('opened');
        });

        this.scrolling.enable();
        document.documentElement.classList.remove('locked');
    }

    open() {
        this.handleOpen();
    }

    closeMenu() {
        this.handleClose();
    }
}